import React from 'react';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

interface NoDataRowProps {
  colSpan?: number;
  message?: string;
  icon?: React.ReactNode;
}

const DefaultIcon = (
  <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="22" fill="#F5F6FA" stroke="#E0E0E0" strokeWidth="2"/>
    <path d="M16 22h16M16 28h10" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const NoDataRow: React.FC<NoDataRowProps> = ({
  colSpan = 4,
  message = 'No data found.',
  icon = DefaultIcon,
}) => (
  <TableRow>
    <TableCell colSpan={colSpan} align="center" sx={{ py: 5, color: 'text.secondary', borderBottom: 'none' }}>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        {icon}
        <Typography variant="body1" sx={{ mt: 2, color: '#888' }}>
          {message}
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
);

export default NoDataRow;
